import { render, staticRenderFns } from "./SpacesEditorTitle.vue?vue&type=template&id=53570f01&scoped=true"
import script from "./SpacesEditorTitle.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorTitle.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorTitle.scss?vue&type=style&index=0&id=53570f01&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53570f01",
  null
  
)

export default component.exports